import { useState, useEffect, useCallback } from 'react'
import showAlert from 'utils/showAlert'
import { cgiCallWrapper } from 'utils/cgiCallWrapper'

const useUpdateList = props => {
    const {
        updateDataAPI,
        genUpdateDataAPIParams,
        derivedData,
        dataFormatter,
        searchName = 'name',
        filterName = 'status',
        page: defaultPage = 1,
        pageSize: defaultPageSize = 20,
        filterSelectValue: defaultFilterSelectValue = '',
    } = props
    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(defaultPage)
    const [pageSize, setPageSize] = useState(defaultPageSize)
    const [totalSize, setTotalSize] = useState(0)
    const [filterText, setFilterText] = useState('')
    const [filterTextInput, setFilterTextInput] = useState('')
    const [filterSelectValue, setFilterSelectValue] = useState(defaultFilterSelectValue)
    const [data, setData] = useState([])

    const handlePageSizeChange = (_page, _pageSize) => {
        setPage(_page)
        setPageSize(_pageSize)
    }

    const handleFilterTextClear = () => {
        setFilterTextInput('')
        setFilterText('')
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            setFilterText(filterTextInput)
        }
    }

    const handleSearchIconClick = e => {
        setFilterText(filterTextInput)
    }

    const handleFilterChange = (e, val) => {
        setFilterTextInput(val)
    }
    const handleFilterSelectOnchange = (e, val) => {
        setFilterSelectValue(val)
    }

    const handlePageChange = (e, val) => setPage(val)

    const updateList = useCallback(async () => {
        if (updateDataAPI) {
            // 拉取APP列表数据
            try {
                let params = {}
                // 支持上层应用独立构造搜索过滤参数
                if (typeof genUpdateDataAPIParams === 'function') {
                    params = genUpdateDataAPIParams({
                        filterName,
                        filterText,
                        searchName,
                        filterSelectValue,
                    })
                } else {
                    // 默认搜索文本的字段名根据 searchName & filterName 来定
                    if (filterText) {
                        params[searchName] = filterText
                    }
                    if (filterSelectValue && filterSelectValue >= 0) {
                        params[filterName] = filterSelectValue
                    }
                }
                params.psize = pageSize
                params.pno = page
                const res = await cgiCallWrapper(updateDataAPI, params)
                if (res.c === 200 && res.b) {
                    const list = res.b.list || []
                    // 更新列表数据
                    const formattedData = dataFormatter ? dataFormatter(list) : list
                    setData(formattedData)
                    setLoading(false)
                    setTotalSize(res.b.totalRecord || 0)
                } else {
                    setLoading(false)
                    showAlert('error', `获取列表失败: ${res.d || '未知原因'}`)
                }
            } catch (e) {
                setLoading(false)
                showAlert('error', `网络错误: 获取列表失败`)
            }
        } else {
            setLoading(false)
            setData(derivedData)
        }
    }, [
        dataFormatter,
        derivedData,
        filterName,
        filterSelectValue,
        filterText,
        genUpdateDataAPIParams,
        page,
        pageSize,
        searchName,
        updateDataAPI,
    ])

    useEffect(() => {
        updateList()
    }, [updateList])

    return {
        state: {
            loading,
            page,
            pageSize,
            totalSize,
            filterText,
            filterTextInput,
            filterSelectValue,
            data,
        },
        setState: {
            handleFilterTextClear,
            handlePageSizeChange,
            handleKeyPress,
            handleSearchIconClick,
            handleFilterChange,
            handlePageChange,
            handleFilterSelectOnchange,
            updateList,
            setData,
        },
    }
}

export default useUpdateList
